import { Icon } from '@iconify-icon/react';
import { useState } from 'react';
import { cn } from '#lib/helpers/class.js';
import FloatingTooltip from '#components/tooltip.jsx';
import { compareDate } from '#lib/helpers/date.js';
import { Link } from 'react-router-dom';
import Button from '#lib/components/button.jsx';
import { LoadingIndicator } from '#lib/components/loading.jsx';

export default function TasksCard(props) {
    const { itineraries, isLoading } = props;

    const tasks = itineraries?.reduce((acc, itinerary) => {
        return acc.concat(
            itinerary.tasks.map((task) => {
                return { ...task, itineraryId: itinerary.id };
            })
        );
    }, []);

    const sortedTasks = tasks?.sort((a, b) => {
        if (!b.dueDate) return -1;
        const dateA = new Date(a.dueDate).getTime();
        const dateB = new Date(b.dueDate).getTime();
        return dateA - dateB;
    });

    if (isLoading) {
        return (
            <div className="h-[340px] md:h-[300px] w-full md:w-1/2 flex justify-center items-center md:shadow-lg rounded-lg md:rounded-xl">
                <LoadingIndicator />
            </div>
        );
    }

    return (
        <div className="h-[300px] rounded-lg w-full md:w-1/2 flex flex-col justify-start gap-2 p-3 md:shadow-lg md:rounded-xl border-b border-b-neutral-200 md:border-none">
            <h2 className="font-bold text-lg mb-1">{_t.home.tasksTitle()}</h2>
            <div className="contents">
                {sortedTasks && sortedTasks.length > 0 ? (
                    sortedTasks?.slice(0, 6)?.map((task, index) => {
                        const inputDate = task.dueDate;
                        const { isExpiring, isExpired } = compareDate(inputDate);

                        return (
                            <Link to={`/manage/itinerary/edit/${task.itineraryId}?taskName=${task.name}`} key={index}>
                                <div className="flex justify-between items-center rounded-lg px-2 hover:bg-primary-50 text-neutral-900 hover:text-primary-600">
                                    <span className="flex items-center gap-2 italic overflow-hidden">
                                        {isExpiring && (
                                            <FloatingTooltip
                                                content={_t.crud.itinerary.headers.dueTasks()}
                                                placement="top"
                                            >
                                                <Icon
                                                    icon="ic:round-error-outline"
                                                    width="1.2rem"
                                                    height="1.2rem"
                                                    className="text-amber-500 pt-[6px]"
                                                />
                                            </FloatingTooltip>
                                        )}
                                        {isExpired && (
                                            <FloatingTooltip
                                                content={_t.crud.itinerary.headers.expiredTasks()}
                                                placement="top"
                                            >
                                                <Icon
                                                    icon="ic:round-error-outline"
                                                    width="1.2rem"
                                                    height="1.2rem"
                                                    className="text-red-500 pt-[6px]"
                                                />
                                            </FloatingTooltip>
                                        )}
                                        <span className="py-1 text-ellipsis truncate whitespace-nowrap ">
                                            {task.name}
                                        </span>
                                    </span>
                                    <Icon
                                        icon="line-md:arrow-small-right"
                                        width="1.4rem"
                                        height="1.4rem"
                                        className="text-primary-600"
                                    />
                                </div>
                            </Link>
                        );
                    })
                ) : (
                    <section className="h-full relative">
                        <div className="absolute top-0 left-0 w-full h-full bg-neutral-100 flex flex-col justify-center items-center gap-5 rounded-lg">
                            <p className="w-2/3 text-center text-neutral-700 italic font-semibold">
                                {_t.home.noTasks()}
                            </p>
                        </div>
                    </section>
                )}
            </div>
        </div>
    );
}
